export * from './CursorStyle';
export {default} from './CursorStyle';
